<template>
    <div>
        <p-search-screen title="Product Transfers"
                      api-destination="productTransfers"
                      :filters="filters"
                      :filterBy="filterBy"
                      :fields="fields"
                      ref="transfersSearchScreen"

                      >
            <template v-slot:actionButtons>
                <router-link to="producttransfers/new"
                             class="btn btn-primary">
                    <b-icon-plus></b-icon-plus> Add Transfer
                </router-link>
            </template>
            <template v-slot:belowSearch>
                <p-form>
                    <b-row>
                        <b-col>
                        <p-checkbox
                            label="Open"
                            v-model="filters.open"
                        />
                        <p-checkbox
                            label="In Transit"
                            v-model="filters.inTransit"
                        />
                        <p-checkbox
                            label="Closed"
                            v-model="filters.closed"
                        />

                        </b-col>
                    </b-row>
                </p-form>
            </template>
             <template v-slot:cell(view)="{ item }">
                <p-button
                variant="outline-primary"
                size="sm"
                @click='viewProductTransfer(item)'
                > View
                </p-button
                >
            </template>
        </p-search-screen>

    </div>
</template>

<script>
    import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
    import { datetimeToLocalTimeFormatter } from '../../components/Common/Formatters.js';


    export default {
        mixins: [SearchStorage],
        data() {
            return {
                filterName: 'ProductTransfersFilter',
                filters: {
                    automatic: "",
                    perPage: 100,
                    sortBy: 'sentDateTime',
                    sortDesc: true,
                    searchBy: 'All',
                    open: true,
                    inTransit: true,
                    closed: false,
                },
                filterBy: ['All', 'Transfer #', 'Location of Origin', 'Destination'],
                fields: [
                    {
                        key: 'view',
                        label: 'Details',

                    },
                    {
                        key:'transferNumber',
                        label: 'Transfer #',
                        sortable: false
                    },
                    {
                        key:'lastModifiedDateTime',
                        label: 'Date & Time Last Update',
                        sortable: false,
                        formatter: datetimeToLocalTimeFormatter
                    },
                     {
                        key:'sentDateTime',
                        label: 'Date & Time Sent ',
                        sortable: true,
                        formatter: datetimeToLocalTimeFormatter
                    },
                    {
                        key:'locationOfOrigin',
                        label: 'Location of Origin',
                        sortable: false
                    },
                     {
                        key:'destination',
                        label: 'Destination',
                        sortable: false
                    },
                     {
                        key:'status',
                        label: 'Status',
                        sortable: false
                    }
                ],
                totalRows: 0,
            };
        },
        methods: {
            viewProductTransfer(item){
                this.$router.push('/producttransfers/'+ item.productTransferId);
            }
        }
    };
</script>
